import React, { useState } from 'react';
import EmailIcon from '../assets/images/email.png';
import TimeIcon from '../assets/images/clock.png';
import PhoneIcon from '../assets/images/telephone.png';
import LocationIcon from '../assets/images/location.png';
import halfRound from '../assets/images/half_round.png';
import axios from 'axios';
import { FaEnvelope, FaPaperPlane, FaPhoneAlt, FaRegCommentDots, FaUser } from 'react-icons/fa';

// API base URL configuration: uses full URL in production, empty for local proxy
const API_BASE = process.env.NODE_ENV === 'production' ? 'https://shuchiai.com' : '';


const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    comments: ''
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const response = await axios.post(API_BASE + '/lulto_admin/contact/addContact', formData);

      if (response.data.success) {
        setMessage({
          text: 'Thank you! Your message has been sent successfully.',
          type: 'success'
        });

        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          comments: ''
        });
      }
    } catch (error) {
      setMessage({
        text: error.response?.data?.message || 'Something went wrong. Please try again.',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page" id="contact">
      <div className="home-hero-round-bg" aria-hidden="true">
        <img src={halfRound} alt="" className="home-hero-round-img" />
      </div>

      <div className="contact-container">
        <section className="contact-hero-panel">
          <div className="contact-left">
            <div className="contact-left-content">
              <span className="contact-tag"><span aria-hidden="true"></span> Contact Us</span>
              <h1 className="contact-main-heading">
                Let&apos;s build something <span>great together.</span>
              </h1>
              <p className="contact-description">
                Have a project in mind or just want to say hello? Tell us a little
                about it and our team will get back to you shortly.
              </p>
            </div>
          </div>

          <div className="contact-form-card">
            <span className="form-kicker">Start a conversation</span>
            <h2 className="form-title">Send Us a Message</h2>
            <p className="form-instruction">Share your idea with us. We usually reply within one business day.</p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <FaUser className="form-field-icon" />
                  <label className="sr-only" htmlFor="contact-name">Your name</label>
                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    className="form-input"
                    required
                  />
                </div>

                <div className="form-group">
                  <FaEnvelope className="form-field-icon" />
                  <label className="sr-only" htmlFor="contact-email">Email address</label>
                  <input
                    id="contact-email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email Address"
                    className="form-input"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <FaPhoneAlt className="form-field-icon" />
                <label className="sr-only" htmlFor="contact-phone">Phone number</label>
                <input
                  id="contact-phone"
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="form-input"
                  required
                />
              </div>

              <div className="form-group">
                <FaRegCommentDots className="form-field-icon form-textarea-icon" />
                <label className="sr-only" htmlFor="contact-message">Your message</label>
                <textarea
                  id="contact-message"
                  name="comments"
                  value={formData.comments}
                  onChange={handleChange}
                  placeholder="Your Message"
                  className="form-textarea"
                  rows="5"
                  required
                ></textarea>
              </div>

              {message.text && (
                <div className={`form-message ${message.type}`}>
                  {message.text}
                </div>
              )}


              <button
                type="submit"
                className="form-submit-btn"
                disabled={loading}
              >
                <span>{loading ? 'Sending...' : 'Send Message'}</span>
                <FaPaperPlane className="form-submit-icon" />
              </button>
            </form>
          </div>
        </section>

        <section className="contact-info-strip">
          <div className="contact-detail-item">
            <span className="contact-icon"><img src={EmailIcon} alt="Email" /></span>
            <span><span className="contact-detail-title">Email Us</span>
            <a className="contact-text" href="mailto:embeepay141@gmail.com">embeepay141@gmail.com</a></span>
          </div>
          <div className="contact-detail-item">
            <span className="contact-icon"><img src={PhoneIcon} alt="Phone" /></span>
            <span><span className="contact-detail-title">Call Us</span>
            <a className="contact-text" href="tel:+919876543210">+91 84608 21006</a></span>
          </div>
          <div className="contact-detail-item">
            <span className="contact-icon"><img src={TimeIcon} alt="Working hours" /></span>
            <span><span className="contact-detail-title">Working Hours</span>
            <span className="contact-text">Mon-fri, 9:30 AM - 6:30 PM</span></span>
          </div>
          <div className="contact-detail-item">
            <span className="contact-icon"><img src={LocationIcon} alt="Location" /></span>
            <span><span className="contact-detail-title">Our Location</span>
            <span className="contact-text">Surat, Gujarat, India</span></span>
          </div>
        </section>

        <section className="contact-cta-panel">
          <div className="contact-cta-icon">
            <FaPaperPlane />
          </div>
          <div className="contact-cta-copy">
            <h2>Let's Turn Your Ideas Into Reality</h2>
            <p>We're excited to collaborate and help you build something amazing.</p>
          </div>
          <a className="contact-cta-button" href="#contact">
            <span>Start Your Project</span>
            <FaPaperPlane />
          </a>
        </section>

      </div>
    </div>
  );
}

export default Contact;
